export default "__VITE_ASSET__DouwZ$o3__";